'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAggregateEvents = exports.parseAutoImportEvents = exports.parseEvents = exports.getFilter = exports.getEvents = exports.getAggregateEvents = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _reselect = require('reselect');

var _isEmpty = require('lodash/lang/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _helpers = require('../../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAggregateEvents = exports.getAggregateEvents = function getAggregateEvents(state) {
  return state.events.aggregateEvents;
};
var getEvents = exports.getEvents = function getEvents(state) {
  return state.events.events;
};
var getFilter = exports.getFilter = function getFilter(state) {
  return state.events.filter;
};

var parseEvents = exports.parseEvents = (0, _reselect.createSelector)(function (object) {
  return object.events;
}, function (events) {
  if ((0, _isEmpty2.default)(events)) return [];
  return events.map(function (event) {
    return (0, _extends3.default)({
      id: event.id,
      affectedEntity: (0, _helpers.generateEventEntityName)(event.affectedEntity)
    }, (0, _helpers.generateEventStatus)(event.result));
  });
});

var parseAutoImportEvents = exports.parseAutoImportEvents = (0, _reselect.createSelector)(function (object) {
  return object.events;
}, function (events) {
  if ((0, _isEmpty2.default)(events)) return [];
  return events.map(function (event) {
    return {
      id: event.id,
      affectedEntity: (0, _helpers.generateEventEntityName)(event.affectedEntity),
      resultDisplay: (0, _helpers.generateResultDisplay)(event.result)
    };
  });
});

var parseAggregateEvents = exports.parseAggregateEvents = (0, _reselect.createSelector)(getAggregateEvents, function (aggregateEvents) {
  if ((0, _isEmpty2.default)(aggregateEvents)) return [];
  return aggregateEvents.map(function (event) {
    var ruleObj = void 0;
    var rulesetObj = void 0;

    if (event.actor) {
      ruleObj = event.actor.find(function (actor) {
        return actor.type === "Rule";
      });
      rulesetObj = event.actor.find(function (actor) {
        return actor.type === "Rule Set";
      });
    }

    return {
      key: '' + event.transactionId + (Math.floor(Math.random() * 9000) + 100),
      transactionId: event.transactionId,
      origin: event.origin,
      aggregateEvent: (0, _helpers.generateAggregateEventDisplayName)(event),
      trigger: (0, _helpers.generateAggregateEventTriggerDisplayName)(event),
      timestamp: (0, _helpers.generateAggregateEventDisplayTime)(event.timestamp),
      arReportUrl: (0, _helpers.getARLinkForEvent)(event.sampleResult),
      ruleId: ruleObj ? ruleObj.id : null,
      rulesetId: rulesetObj ? rulesetObj.id : null
    };
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/store/events/selectors/index.js
// module id = 3395
// module chunks = 2